"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFilter = void 0;
/**
 * Recommendations in the context of a product should contain the id of the product for which the
 * recommendation will be generated. For example, to get a list of products similar to product A,
 * provide the product ID of A.
 */
var ProductFilter = /** @class */ (function () {
    /** @param filterValue Product id to filter */
    function ProductFilter(filterValue) {
        this.enableMultiple = true;
        this.urlParam = 'filterProduct';
        this.value = filterValue;
    }
    return ProductFilter;
}());
exports.ProductFilter = ProductFilter;
//# sourceMappingURL=ProductFilter.js.map